import { Reset } from "styled-reset";

import KakaoMap from "./component/KakaoMap";

function App() {
  return (
    <>
      <Reset />

      <KakaoMap />
    </>
  );
}

export default App;
